// extracted by mini-css-extract-plugin
export default {"container":"numNotification_container__29L5R","icon":"numNotification_icon__kw-IG"};